export default {
  init() {
    // JavaScript to be fired on the about us page
  },
  finalize() {
  	
    $('#presence a').on('click',function(event){
      event.preventDefault();

      var elemento = $(this).attr('data-order');

      $('.img-mapa img.img-element').addClass('d-none');
      $('.img-mapa').find('[data-order='+elemento+']').removeClass('d-none');
      console.log(elemento);

    });
    
  	$('#presena a').on('click',function(event){
  		event.preventDefault();

  		var elemento = $(this).attr('data-order');

  		$('.img-mapa img.img-element').addClass('d-none');
  		$('.img-mapa').find('[data-order='+elemento+']').removeClass('d-none');
  		console.log(elemento);

  	});

    $('#prsence a').on('click',function(event){
      event.preventDefault();

      var elemento = $(this).attr('data-order');

      $('.img-mapa img.img-element').addClass('d-none');
      $('.img-mapa').find('[data-order='+elemento+']').removeClass('d-none');
      console.log(elemento);

    });
    $('#presencia a').on('click',function(event){
      event.preventDefault();

      var elemento = $(this).attr('data-order');

      $('.img-mapa img.img-element').addClass('d-none');
      $('.img-mapa').find('[data-order='+elemento+']').removeClass('d-none');
      console.log(elemento);

    });

    

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/cabopol.js